import { useState } from 'react';

interface Option {
	label: string;
	value: string;
}

interface UseDropdownInputOptions {
	initialValue?: string;
	options: Option[];
}

interface UseDropdownInput {
	value: string;
	options: Option[];
	onChange: (value: string) => void;
}

export const useDropdownInput = ({
	initialValue = '',
	options,
}: UseDropdownInputOptions): UseDropdownInput => {
	const [value, setValue] = useState(initialValue);

	const onChange = (value: string) => {
		setValue(value);
	};

	return { value, options, onChange };
};
